// @ts-nocheck
import { isNaN } from "lodash";
import { isTimeTBD } from "./calculations";
import { USER_ROLES } from "../../staticData/userRoles";
import { DOES_NOT_EXIST } from "../constants/configs";

/**
 * function to format date to "MMM DD, YYYY"
 * @param {string} date
 * @returns {string} string
 */
export function formatDate(date) {
  try {
    const dt = new Date(date);
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric"
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    return formatter.format(dt);
  } catch (_) {
    return date;
  }
}

/**
 * function to format date from "YYYY-MM-DD" to "MMM DD, YYYY"
 * @param {string} date
 * @returns {string} string
 */
export function formatDateWithHyphen(date) {
  try {
    const monthArr = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const [year, month, day] = date.split("-");
    return `${monthArr[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
  } catch (_) {
    return date;
  }
}

/**
 * function to convert date from DD/MM/YYYY to above format
 * @param {string} data
 * @returns {string} string
 */
export function convertDate(data) {
  try {
    const [day, month, year] = data.split("/");
    if (day.length < 2 || month.length < 2 || year.length < 4)
      throw new Error("formatting wrong");
    return formatDate(`${month}-${day}-${year}`);
  } catch (_) {
    return data;
  }
}

export function convertStaticDate(date) {
  try {
    const [year, month, day] = date.split("/");
    return `${day}/${month}/${year}`;
  } catch (_) {
    return date;
  }
}

export function hideSomeEmail(email) {
  const [name, domain] = email.split("@");
  const hide = name.slice(3).replace(/./g, "*");
  return `${name.slice(0, 3)}${hide}@${domain}`;
}

// it should show like 90 which is the input to  01:30 the output
export function timerFormatter(time) {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}

// get time of my zone
export function getTimeOnMyZone(time) {
  const ftime = new Date(time);
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  };
  const localTimeString = ftime.toLocaleTimeString("en-US", options);
  return localTimeString;
}

export function formatTimeUnits(timeUnitVal) {
  if (timeUnitVal < 10) {
    return `0${timeUnitVal}`;
  } else return timeUnitVal;
}

export function removeOnlyOffset(dateTimeString) {
  try {
    // Extract the date and time parts
    var dateTimeParts = dateTimeString.split(/[T]/);
    var datePart = dateTimeParts[0];
    var timePart = dateTimeParts[1].split(".")[0]; // Remove milliseconds
  } catch (err) {
    return dateTimeString;
  }

  // Return the date and time parts without the offset
  return datePart + "T" + timePart;
}

// get the name and last initial of the name
export function getLastNameHidden(fullName) {
  if (!fullName) return;
  const nameParts = fullName.split(" ");

  if (nameParts.length === 1) {
    return fullName;
  }

  const lastNameInitial = nameParts[nameParts.length - 1][0] + ".";

  nameParts[nameParts.length - 1] = lastNameInitial;

  const truncatedName = nameParts.join(" ");

  return truncatedName;
}

/**
 * function to format phone number from 1234567890 to 123-456-7890
 * @param {string} number
 * @returns {string} string
 */
export function phoneNumberFormat(number) {
  if (!number) return "";
  if (`${number}`.match(/^\d{3}-\d{3}-\d{4}$/)) {
    return number;
  }
  let cleaned = `${number}`.replace(/\D/g, "");
  // Strip leading US country code so autofilled values like "+15555686870"
  // / "15555686870" normalize to a plain 10-digit number instead of leaking
  // the raw string (which fails the "must be of 10 digit" form validation).
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    cleaned = cleaned.slice(1);
  }
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return number;
}

/**
 * function to format phone number from 123-456-7890 to 1234567890
 * @param {string} number
 * @returns {string} string
 */
export function phoneNumberForApi(number) {
  if (!number) return "";
  return number.replace(/-/g, "");
}

/**
 * funciton to return initilas of the string
 * examples: "Hello There World" => "HW"
 * @param {string} str
 * @returns {string} string
 */
export function getFirstAndLastInitials(str) {
  if (!str) return "";
  const names = str.split(" ");
  if (names.length === 1) {
    return names[0].charAt(0);
  }
  return (
    names[0].charAt(0).toUpperCase() +
    names[names.length - 1].charAt(0).toUpperCase()
  );
}

/**
 * function to format date and time to "MMM DD, YYYY at HH:MM AM/PM"
 * @param {string} date
 * @returns {string} string
 */
export function formatDateTime(date) {
  try {
    const dt = new Date(date);

    const dateOptions = {
      month: "short",
      day: "2-digit",
      year: "numeric"
    };

    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true // Use 12-hour clock with AM/PM
    };

    const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);
    const timeFormatter = new Intl.DateTimeFormat("en-US", timeOptions);

    const formattedDate = dateFormatter.format(dt);
    const formattedTime = timeFormatter.format(dt);

    return `${formattedDate} at ${formattedTime}`;
  } catch (_) {
    return date;
  }
}

// Example usage:
// console.log(formatDateTime("2024-09-20T20:00:00Z")); // Output: "Sep 20, 2024 at 08:00 PM"

/**
 * function to get the generator name for doc on saved drafts
 * @param {object} obj
 * @returns {string}
 */
export function getGeneratorName(obj) {
  if (obj?.eventCreatedBy?.fullName) {
    return obj?.eventCreatedBy?.fullName;
  } else if (obj?.eventCreatedBy?.firstName && obj?.eventCreatedBy?.lastName) {
    return `${obj?.eventCreatedBy?.firstName} ${obj?.eventCreatedBy?.lastName}`;
  } else {
    return "Guest User";
  }
}

/**
 * function to get the selected option
 * @param {String} st
 * @return {String}
 */
export function getSelectedOption(str) {
  switch (str?.toLowerCase()) {
    case "meal provided":
      return "MP";
    case "1 hour walk away":
      return "WA";
    default:
      return "N/A";
  }
}

/**
 * function to get the overnight value
 * @param {Booleand} str
 * @returns {String}
 */
export function getOvernightValue(value) {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

/**
 * function to get the number of hours if time in and out are tbd
 * @param {Object} value
 * @returns {String}
 */
export function getNumberOfHours(value) {
  if (isTimeTBD(value?.timeIn) || isTimeTBD(value?.timeOut)) {
    return "N/A";
  } else {
    return `${value?.numberOfHours} ${value?.numberOfHours > 1 ? "s" : ""}`;
  }
}

/**
 * function to roundoff values
 * @param {Number} value
 */
export function roundOffValue(value) {
  try {
    if (isNaN(value)) return 0;
    // return Math.round(value);
    return parseFloat(value).toFixed(2);
  } catch (e) {
    return 0;
  }
}
/**
 * function to format number beautifully
 * @params {Number} num
 */
export function formatNumber(num) {
  return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
}

export const getMobileFormat = (input) => {
  const formattedInput = input
    .replace(/\D/g, "")
    .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
      let formattedNumber = "";
      if (p1) {
        formattedNumber += p1;
      }
      if (p2) {
        formattedNumber += "-" + p2;
      }
      if (p3) {
        formattedNumber += "-" + p3;
      }
      return formattedNumber;
    });

  return formattedInput;
};

/**
 * get user name beautifylly
 */
export const getUserRoleBeautifully = (role) => {
  switch (role) {
    case USER_ROLES.SUPERADMIN:
      return "Super Admin";
    case USER_ROLES.ADMIN:
      return "Admin";
    case USER_ROLES.CLIENT:
      return "Client";
    case USER_ROLES.COORDINATOR:
      return "Coordinator";
    case USER_ROLES.CONTRACTOR:
      return "Contarctor";
    default:
      return role;
  }
};

/**
 * get total users array and show message users
 */
export const getFirstUsersAndCount = ({ usersArr = [], showCount = 1 }) => {
  const totalUsers = usersArr.length;
  const firstUsers = usersArr.slice(0, showCount);
  const restUsers = Math.max(totalUsers - showCount, 0);

  const returnString = firstUsers
    ?.map((u) => u?.preferredName || u?.name)
    .join(", ");

  if (restUsers > 0) {
    return `${returnString} and ${restUsers} other${
      restUsers === 1 ? "" : "s"
    }`;
  }

  return returnString;
};

/**
 * get sms status
 */

/**
 * get sanitized filename
 */
export const getSanitizedFileName = ({ name }) => {
  return name
    .trim()
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/\s+/g, " ");
};

/**
 * capitalize words
 */
export const capitalizeWords = (sentence) => {
  return sentence.replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Convert ENUM_STYLE_STRING to "Title Case String"
 * @param {string} enumStr
 * @returns {string}
 */
export const formatEnumValue = (enumStr) => {
  if (!enumStr || typeof enumStr !== "string") return "";

  return enumStr
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * get position name with suffix
 */
export const getPositionNameWithSuffix = ({ pos }) => {
  return `${pos?.positionName}${pos?.positionOrder ? `-${pos?.positionOrder}` : ""}`;
};

/**
 * ignore email with emaildoesntexistforthisuser.com suffix
 * @param {object} obj
 * @param {string} obj.email
 * @returns {string}
 */
export const getEmailSanitized = ({ email }) => {
  if (email == "NA") return "";
  if (email?.includes(DOES_NOT_EXIST.email)) return "";
  else return email;
};

/**
 * remove last name from preferred name
 */
export const removeLastName = ({ preferredName, lastName }) => {
  if (!preferredName) return "";
  return preferredName?.trim()?.split(lastName)?.[0];
};

/**
 * Format a numeric-ish value as a 2-decimal money string (no currency symbol).
 * Coerces non-finite/invalid input to "0.00" — prevents "$NaN" cells.
 * @param {unknown} value
 * @returns {string} e.g. "1234.50"
 */
export const formatCurrency = (value) => {
  const n = typeof value === "number" ? value : Number.parseFloat(value);
  return (Number.isFinite(n) ? n : 0).toFixed(2);
};

/**
 * Join a person's first and last name — null-safe, trimmed, single-spaced.
 * @param {string} [first]
 * @param {string} [last]
 * @returns {string} e.g. "Jane Doe" ("" if both are missing)
 */
export const getFullName = (first, last) => {
  return `${first ?? ""} ${last ?? ""}`.trim().replace(/\s+/g, " ");
};